import axios from "axios";
import { APIClient, setAuthorization } from "../../../helpers/api_helper";
import { jwtDecode } from "jwt-decode";

const AUTHORITIES = ['ADMIN', 'SUPER_ADMIN'];

export const authUser = async (data) => {
    try {
        const response = await axios.post(process.env.REACT_APP_KEYCLOAK_SERVER, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        });

        if (response) setAuthorization(response.access_token);
            
        const token_parsed = jwtDecode(response.access_token);
        const roles = token_parsed.realm_access.roles.filter((item) => item === 'SUPER_ADMIN' || item === 'ADMIN');

        if (AUTHORITIES.some(r => roles.includes(r))) {
            saveUserToSessionStorage({
                token: response.access_token,
                ...token_parsed,
                roles
            });
            
            return { roles, isAuthorized: true };
        } else {
            return { roles, isAuthorized: false };
        }
    } catch (e) {
        if (!e.response) {
            return Promise.reject("Problème de connexion. Vérifiez votre réseau et réessayez.");
        }
        if (e.response.status === 401) {
            return Promise.reject("Oups !!! Vous n'êtes pas autorisé à vous connecter. Vérifiez vos identifiants.");
        }
        if (e.response.status === 403) {
            return Promise.reject("Accès interdit. Vous n'avez pas les autorisations nécessaires.");
        }
        return Promise.reject("Une erreur est survenue lors de la connexion. Veuillez réessayer.");
    }
}

export const saveUserToSessionStorage = (user) => {
    if (user) {
        const userData = {
            token: user.token,
            fullName: user.name,
            email: user.email,
            roles: user.roles,
            company: user.company,
            companyName: user.companyName || user.company,
            superAdminId: user.superAdminId,
            userId: user.userId,
            isSuperAdmin: !!user.roles.includes('SUPER_ADMIN'),
            Phone: user.phone || 'Numéro non fourni',
            address:user.address
        };
        
        sessionStorage.setItem('authUser', JSON.stringify(userData));
    }
};


export const logout = () => {
    sessionStorage.clear();
    return true;
}
export const changePassword = async ({ email, newPassword }) => {

    if (!email || !newPassword) {
      throw new Error("Le mot de passe ou l'email sont manquants.");
    }
  
    try {
      const response = await fetch(
        `http://41.82.226.245:2080/api/v1/auth/${encodeURIComponent(email)}/newPassword?email=${encodeURIComponent(email)}&newPassword=${encodeURIComponent(newPassword)}`,
        {
          method: 'PUT',
          headers: {
          },
        }
      );
  
      const data = await response.text();
      if (!response.ok) {
        throw new Error(data || 'Erreur inconnue');
      }
  
      return data; 
    } catch (error) {
      console.error('Erreur lors de la mise à jour du mot de passe :', error);
      throw error;
    }
  };
